import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlighter'
})
export class HighlighterPipe implements PipeTransform {


	
transform(value: any, args: any,type:string): unknown {

    if(!args) return value;

		let query = args;

	   	if ( query ) {
	        value = value.changingThisBreaksApplicationSecurity || value;

	        let tagRE    = new RegExp('<[^<>]*>', 'ig');

	        // get ist of tags
	        let tagList  = value.match( tagRE );

	        // Replace tags with token
	        let tmpValue = value.replace( tagRE, '$!$');

	        // Replace search words
	        value = tmpValue.replace(
	            new RegExp(query, 'gi'),
	            '<mark>$&</mark>'
	        );

	        // Reinsert HTML
	        for (let i = 0; value.indexOf('$!$') > -1; i++) {
	            value = value.replace('$!$', tagList[i]);
	        }
	    }

      return value;
  }





 /* transform(value: any, args: any,type:string): unknown {
    if(!args) return value;
    console.log(value);
    console.log(args);
    console.log(type);

    if(type==='full'){
console.log('v');
      const re = new RegExp("\\b("+args+"\\b)", 'igm');
      value= value.replace(re, '<span class="highlighted-text">$1</span>');

    }else{
console.log('vj');

      const re = new RegExp(args, 'igm');
      value= value.replace(re, '<span class="highlighted-text">$&</span>');

    }

      return value;
  }*/

}
